import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';

/** Bo's family flat: living room with the aquarium and console, a kitchen, and Bo's bedroom. */
const b = new MapBuilder(14, 11, ' ');
b.room(0, 0, 14, 11, '.');
b.room(8, 0, 6, 7, ';');
b.fill(10, 6, 2, 1, 'd');
b.fill(1, 1, 4, 2, 'k');
b.fill(6, 10, 2, 1, 'D');

const at = (tx: number, ty: number) => ({ x: px(tx), y: px(ty) });
const box = (tx: number, ty: number, tw: number, h = 10): Decor['solid'] => ({ x: px(tx) + 1, y: px(ty) - h, w: px(tw) - 2, h });

const decor: Decor[] = [
  { kind: 'window', x: px(5), y: 0, w: px(2), wall: true },
  { kind: 'window', x: px(11), y: 0, w: px(2), wall: true },
  { kind: 'poster', x: px(9), y: 3, wall: true, variant: 2 },
  { kind: 'kitchenCounter', ...at(2, 3), w: px(3), solid: box(1, 3, 3, 10) },
  { kind: 'bunkBed', ...at(12.5, 4), solid: box(12, 4, 1, 22) },
  { kind: 'livingSofa', ...at(4, 9), solid: box(2, 9, 4, 10) },
  { kind: 'shoeCabinet', ...at(9, 10), solid: box(8.5, 10, 1, 6) },
  { kind: 'laundryRack', ...at(12, 9) },
];

export const bo: MapDef = {
  id: 'bo',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: true,
  theme: { wallFace: '#dfe9ef', wallLight: '#f1f7fa', wainscot: '#5a86a8', wallTop: '#24313a' },
  doors: [{ tiles: [[6, 10], [7, 10]], to: 'town', arrive: { x: px(48) + 8, y: px(55), facing: 'down' } }],
  decor,
  areas: [{ key: 'bo', rect: { x: 0, y: 0, w: px(14), h: px(11) } }],
  lights: [
    { x: px(4), y: px(6), r: 100, color: '255,236,200' },
    { x: px(11), y: px(3), r: 70, color: '220,235,255' },
    { x: px(6), y: px(3), r: 50, color: '120,200,255' },
  ],
};
